var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3503 0.648851C12.9218 0.219949 12.3614 0 11.8011 0C11.2407 0 10.6803 0.219949 10.2518 0.648851L9.86722 1.02276L1.31875 9.57879L0.0331866 13.2739C-0.120642 13.7138 0.285905 14.1207 0.725415 13.9668L4.4173 12.6801L12.1856 4.90487L13.3394 3.75014C14.2184 2.89233 14.2184 1.50665 13.3503 0.648851ZM4.42829 11.1294L2.87901 9.57879L9.86722 2.5844L11.4165 4.13505L4.42829 11.1294ZM12.5812 2.98031L12.2076 3.35423L10.6474 1.80358L11.0209 1.42967C11.2297 1.20972 11.5044 1.09975 11.8011 1.09975C12.0977 1.09975 12.3724 1.20972 12.5812 1.41867C13.0097 1.84757 13.0097 2.55141 12.5812 2.98031Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPen);
export default __webpack_public_path__ + "static/media/icon_pen.1ad969ea92fe5330d7564c6dc4775cd1.svg";
export { ForwardRef as ReactComponent };